<template>
  <div class="blog-content-container">
    <div class="mt-4 flex blog-breadcrumbs" style="justify-content: flex-end">
      <span class="tx-gray-ad"><a href="/">Home</a>&nbsp;>&nbsp;</span><span class="tx-gray-ad"><a href="/blog">Blogs AutoDeal</a>&nbsp;>&nbsp;</span><span class="tx-blue-1 last-crumb">{{ this.post.title }}</span>
    </div>
    <div class="pt-6">
      <img :src="this.post.cover" :alt="this.post.title"
      class="blog-cover">
      <h3 class="blog-title mt-4">{{ this.post.title }}</h3>
    </div>
    <div class="flex tx-gray-ad blog-icons" style="font-family: montserrat-bold; font-size: 1.4rem;">
      <div class="flex pr-4" style="align-items: center">
        <img src="../../../../../images/blog/blog-author.png" alt="" class="icon" style="width: 25px;">
        Por {{ this.post.author }}
      </div>
      <div class="flex pr-4" style="align-items: center">
        <img src="../../../../../images/blog/blog-date.png" alt="" class="icon" style="width: 22px;">
        {{ postDate }}
      </div>
      <div class="flex" style="align-items: center">
        <img src="../../../../../images/blog/blog-eye.png" alt="" class="icon" style="width: 25px;">
        34
      </div>
    </div>
    <div class="mobile-tags" style="font-family: montserrat-bold;">
      <div class="pt-6 collapsible">
        <div v-if="getKeywords.length > 0">
          <button v-for="n in 2" class="keyword-btn">
            {{ getKeywords[n-1] }}
          </button>
          <img src="/images/chevron-down.png" alt="" style="width: 25px;float:right">
        </div>
      </div>
      <div class="content mt-4">
        <div v-if="getKeywords.length > 2">
          <button v-for="n in getSplicedKeywords.length" class="keyword-btn">
            {{ getKeywords[n] }}
          </button>
        </div>
      </div>
    </div>
    <div class="desk-tags mt-4">
        <button v-for="key in getKeywords" class="keyword-btn">
          {{ key }}
        </button>
    </div>
    <hr />
    <div id="content" class="ql-editor py-4"></div>
    <div class="w-full text-center">
      <a href="/blog" class="tx-blue-1 back-to-blog">Regresar al blog</a>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      customUrl: String
    },
    data: () => ({
      post: 1
    }),
    beforeMount() {
      this.getPost()
    },
    mounted() {
      var coll = document.getElementsByClassName("collapsible");
      var i;

      for (i = 0; i < coll.length; i++) {
        coll[i].addEventListener("click", function() {
          this.classList.toggle("active");
          var content = this.nextElementSibling;
          if (content.style.display === "block") {
            content.style.display = "none";
          } else {
            content.style.display = "block";
          }
        });
      }
    },
    computed: {
      postDate() {
        return this.post.published_at ?? this.post.scheduled_at
      },
      getKeywords() {
        return !this.post.keywords_meta_tag ? [] : this.post.keywords_meta_tag.split(',')
      },
      getSplicedKeywords() {
        return !this.post.keywords_meta_tag ? [] : (this.post.keywords_meta_tag.split(',')).splice(2)
      }
    },
    methods: {
      getPost() {
        axios.get(`/api/${this.customUrl}/blog-post/`)
        .then(({ data }) => {
          this.post = data.data
          document.querySelector('meta[name=description]').content = this.post.description_meta_tag
          document.querySelector('meta[name=keywords]').content = this.post.keywords_meta_tag
        })
      }
    },
    watch: {
      'post.content': function (newValue, oldValue) {
        document.getElementById('content').innerHTML = newValue
      }
    }
  }
</script>

<style scoped>
  .card-container {
    display: flex;
    flex-direction: column;
    background-color: #fff;
    width: 100%;
    height: 330px;
  }
  img.blog-cover {
    width: 100%;
    height: 140px;
    display: block;
    border-radius: 10px;
    object-fit: cover;
  }
  @media screen and (min-width: 1024px) {
    img.blog-cover {
      margin: 0 auto;
      width: 1025px;
      height: 702px;
      object-fit: cover;
      display: block;
    }
  }
  .card-bottom {
    padding: 20px 15px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
  }

  .card-bottom > * {
    font-size: 18px;
    font-weight: 500;
  }

  .card-bottom > h3 {
    font-weight: bold;
    font-size: 1.4rem;
  }

  .card-bottom > p {
    font-size: 0.9rem;
  }

  .card-bottom > a {
    font-size: 0.8rem;
    text-decoration: underline;
  }
  .icon {
    width: 24px;
    /* height: 20px; */
    padding-right: 5px;
  }
  .keyword-btn {
    border-radius: 12px;
    background: black;
    color: #DCFE54;
    padding: 10px 20px;
    font-weight: bold;
    border: none;
    margin-bottom: 10px;
  }
  .keyword-btn:not(:last-child) {
    margin-right: 20px;
  }

  .blog-title {
    font-size: 1.5rem;
    font-weight: bold;
    font-family: 'montserrat-bold';
  }

  @media screen and (min-width: 1024px) {
    .blog-title {
      font-size: 1.5rem;
      font-weight: bold;
    }
  }

  .blog-icons > div {
    align-items: center;
    font-size: .8rem;
  }

  @media screen and (min-width: 1024px) {
    .blog-icons > div {
      font-size: 1rem;
    }
  }

  .back-to-blog {
    font-weight: bold;
    text-decoration: underline;
  }

  .blog-content-container {
    padding: 0;
  }

  @media screen and (min-width: 1024px) {
    .blog-content-container {
      padding: 0 6rem;
    }
  }

  .blog-breadcrumbs {
    font-size: .7rem;
  }

  .blog-breadcrumbs .last-crumb {
    max-width: 100px;
    overflow-x: hidden;
    text-wrap: nowrap;
    text-overflow: ellipsis;
  }

  @media screen and (min-width: 1024px) {
    .blog-breadcrumbs {
      font-size: 1rem;
    }

    .blog-breadcrumbs .last-crumb {
      max-width: 100%;
    }
  }

  .collapsible {
  color: rgb(169, 124, 124);
  cursor: pointer;
  width: 100%;
  border: none;
  text-align: left;
  outline: none;
  font-size: 15px;
}

.content {
  padding: 0 0px;
  display: none;
  overflow: hidden;
}

.desk-tags {
  display: none;
}

@media screen and (min-width: 420px) {
  .mobile-tags {
    display: none;
  }
  .desk-tags {
    display: block;
  }
}
</style>
